"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetTransactionalEmailBodyResponse = exports.UpdateTransactionalEmailBodyResponse = exports.UpdateTransactionalEmailBodyRequest = void 0;
const zod_1 = require("zod");
exports.UpdateTransactionalEmailBodyRequest = zod_1.z.object({
    quoteEmailBody: zod_1.z.string().optional(),
    invoiceEmailBody: zod_1.z.string().optional(),
});
exports.UpdateTransactionalEmailBodyResponse = zod_1.z.object({
    data: zod_1.z.object({
        id: zod_1.z.string(),
    }),
});
exports.GetTransactionalEmailBodyResponse = zod_1.z.object({
    data: zod_1.z.object({
        id: zod_1.z.string(),
        createdAt: zod_1.z.string().date(),
        updatedAt: zod_1.z.string().date(),
        quoteEmailBody: zod_1.z.union([zod_1.z.string(), zod_1.z.null()]),
        invoiceEmailBody: zod_1.z.union([zod_1.z.string(), zod_1.z.null()]),
    }),
});
